var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 99,
    viewBox: "0 0 100 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_599_157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.105 44.1348H86.9783V59.0411H70.105V44.1348ZM41.5635 44.1348H58.4367V59.0411H41.5635V44.1348ZM41.5635 69.6306H58.4367V84.5374H41.5635V69.6306ZM13.022 44.1348H29.8952V59.0411H13.022V44.1348ZM13.022 69.6306H29.8952V84.5374H13.022V69.6306Z",
    fill: "#3A6EE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.47048 94.3008C6.32129 94.3008 3.75842 91.7379 3.75842 88.5887V32.6252H96.2416V62.5537C97.5237 62.774 98.7829 63.0576 100 63.4437V9.47048C100 4.24855 95.7514 0 90.5295 0H9.47048C4.24855 0 0 4.24855 0 9.47048V88.5892C0 93.8111 4.24855 98.0596 9.47048 98.0596H64.1455C63.8051 96.838 63.5482 95.5838 63.3736 94.3012H9.47048V94.3008ZM3.75842 9.47048C3.75842 6.32129 6.32129 3.75842 9.47048 3.75842H19.2286V12.987C17.8695 13.7369 16.9383 15.1665 16.9383 16.8284C16.9383 19.2607 18.9103 21.2326 21.3426 21.2326C23.7749 21.2326 25.7469 19.2607 25.7469 16.8284C25.7469 15.1665 24.8156 13.7369 23.4566 12.987V3.75842H48.8283V12.987C47.4692 13.7369 46.5379 15.1665 46.5379 16.8284C46.5379 19.2607 48.5099 21.2326 50.9422 21.2326C53.3746 21.2326 55.3465 19.2607 55.3465 16.8284C55.3465 15.1665 54.4153 13.7369 53.0562 12.987V3.75842H76.5434V12.987C75.1844 13.7369 74.2531 15.1665 74.2531 16.8284C74.2531 19.2607 76.2251 21.2326 78.6574 21.2326C81.0897 21.2326 83.0617 19.2607 83.0617 16.8284C83.0617 15.1665 82.1304 13.7369 80.7714 12.987V3.75842H90.5291C93.6782 3.75842 96.2411 6.32129 96.2411 9.47048V28.8672H3.75842V9.47048Z",
    fill: "#3A6EE8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_599_157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 98.0592,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.92d5523df01c58f35a9c221a89f7fd37.svg";
export { ForwardRef as ReactComponent };